import { createApi } from './index'
import { getStoredToken } from '../auth/AuthContext'

function getApi() {
    const token = getStoredToken()
    const headers = token ? { Authorization: `Bearer ${token}` } : {}
    return createApi({ headers })
}

export async function fetchAllRecipes() {
    const recipes = await getApi().recipe.getAllRecipes()
    return recipes || []
}

export async function parseRecipe(recipeText, opts) {
    return await getApi().recipe.parseRecipe(recipeText, opts)
}

export async function refineRecipe(recipe, feedback, opts) {
    return await getApi().recipe.refineRecipe(recipe, feedback, opts)
}

export async function saveRecipe(recipe, name) {
    return await getApi().recipe.saveRecipe(recipe, name)
}

export async function fetchRecipe(recipeId) {
    return await getApi().recipe.getRecipe(recipeId)
}

export async function createExecution(recipeId) {
    return await getApi().recipe.createExecution(recipeId)
}

export async function fetchExecution(executionId) {
    return await getApi().execution.getExecution(executionId)
}

export async function startStep(executionId, stepId) {
    return await getApi().execution.startStep(executionId, stepId)
}

export async function prepStep(executionId, stepId) {
    return await getApi().execution.prepStep(executionId, stepId)
}

export async function completeStep(executionId, stepId) {
    return await getApi().execution.completeStep(executionId, stepId)
}

export async function adjustStepTime(executionId, stepId, delta) {
    return await getApi().execution.adjustStepTime(executionId, stepId, delta)
}

export { getApi }
